import errorRoutes from '@/components/Error/routes';

const otherRoutes = [...errorRoutes];

export default otherRoutes;
